import instance from '@/api/business' 
import { User, UserPermissions } from '@/types/User'
import { CreateUser, UpdateUser, DeleteUser, ResetPasswordUser, CreateUserPermissions, DeleteUserPermissions } from './type'

const BASE_URL = '/access/im/user'

export const fetchUser = async () => {
    const response = await instance.post<User[]>(BASE_URL)

    return response.data
}
 
export const createUser = async (data: CreateUser) => {
    const response = await instance.put(BASE_URL, data)

    return response.data
}

export const updateUser = async (data: UpdateUser) => {
    const response = await instance.patch(BASE_URL, data)

    return response.data
}

export const deleteUser = async (data: DeleteUser) => {
    const response = await instance.delete(BASE_URL,  {
        data: data,
    })
    
    return response.data

}
export const resetPasswordUser = async (data: ResetPasswordUser) => {
    const response = await instance.patch('/access/im/resetpassword/user', data)

    return response.data
}


export const fetchUserPermissions = async (SK_USUARIO: number) => {
    const response = await instance.post<UserPermissions[]>('/access/im/userpermissions', {
        SK_USUARIO: SK_USUARIO
    })

    return response.data
}

export const createUserPermissions = async (data: CreateUserPermissions) => {
    const response = await instance.put('/access/im/userpermissions', data)

    return response.data
}

export const deleteUserPermissions = async (data: DeleteUserPermissions) => {
    const response = await instance.delete('/access/im/userpermissions', {
        data: data,
    })

    return response.data
}